console.warn('Внимание подключена новая версия JS API InSales');

import localForage from 'localforage';
import Template from '@/template';
import EventBus from '@/event-bus';
import Shop from '@/shop';
import InsalesCommonCart from '@/cart';
import Compare from '@/compare';
import FavoritesProducts from '@/favorites';
import ajaxAPI from '@/ajax';
import Products from '@/products';
import AjaxSearch from '@/search';
import reCaptchaCommon from '@/google-recaptcha';
import yandexCaptchaCommon from '@/yandex-captcha';
import Tools from '@/tools';

window.localforage = localForage;
window.Template = Template;
window.EventBus = EventBus;
window.Shop = Shop;
window.InsalesCommonCart = InsalesCommonCart;
window.Cart = window.InsalesCommonCart;
window.Compare = Compare;
window.FavoritesProducts = FavoritesProducts;
window.ajaxAPI = ajaxAPI;
window.Products = Products;
window.AjaxSearch = AjaxSearch;
window.reCaptchaCommon = reCaptchaCommon;
window.yandexCaptchaCommon = yandexCaptchaCommon;
window.Tools = Tools;
